import { axios } from '@Root/API'

export const postNewlyRecruitedStudents = payload => {
  return axios.post(`student-engagement/rollover-newly`, payload)
}
